import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { useSizeProp } from '@sgui-plus/hooks'
import { radioEmits } from './radio'
import type { ExtractPropTypes } from 'vue'

export const radioGroupProps = buildProps({
  size: useSizeProp,
  disabled: Boolean,
  modelValue: {
    type: [String, Number, Boolean],
    default: '',
  },
  beforeChange: {
    type: definePropType<() => Promise<boolean> | boolean>(Function),
  },
  validateEvent: {
    type: Boolean,
    default: true,
  },
} as const)

export type RadioGroupProps = ExtractPropTypes<typeof radioGroupProps>

export const radioGroupEmits = radioEmits
export type RadioGroupEmits = typeof radioGroupEmits
